import API from "../api/axios.config";

class ObjectsService {
  
  getObject(id) {
    return API.get(`/objects/${id}`);
  }

  getRandomObjects(limit) {
    return API.get(`/objects/limit/${limit}`);
  }

}

export default new ObjectsService();